import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ModGeneration } from '../enums';

export interface IVdbsResponse {
    acronym: string;
    softwareVersion?: string;
    modGeneration?: ModGeneration;
}

export class VdbsClient {
    constructor(private readonly authService: IAuthServiceV2, private readonly stage: string) {
    }

    public async callVdbsDevicePlatformEndpoint(
        vin: string,
        softwareVersion: boolean,
        modGeneration: boolean,
    ): Promise<IVdbsResponse> {
        const headers: HeadersInit = {
            'Check-Software-Version': softwareVersion.toString(),
            'Check-Mod-Generation': modGeneration.toString(),
        };
        const response = await this.authService.get(`myvw-vdbs-${this.stage}`,
            `v1/vehicles/${vin}/device-platform`, headers);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as IVdbsResponse;
    }

    public async getDevicePlatform(vin: string): Promise<IVdbsResponse | undefined> {
        return this.callDevicePlatformEndpoint(vin, false);
    }

    public async getDevicePlatformWithOnlineDevices(vin: string): Promise<IVdbsResponse | undefined> {
        return this.callDevicePlatformEndpoint(vin, true);
    }

    public async getModGeneration(vin: string): Promise<IVdbsResponse | undefined> {
        return this.callDevicePlatformEndpoint(vin, false);
    }

    private async callDevicePlatformEndpoint(
        vin: string,
        includeOnlineDevices: boolean,
    ): Promise<IVdbsResponse | undefined> {
        const headers: HeadersInit = {
            'Check-Software-Version': includeOnlineDevices.toString(),
            'Check-Mod-Generation': true.toString(),
        };
        let response;

        try {
            response = await this.authService.get(`myvw-vdbs-${this.stage}`,
                `v1/vehicles/${vin}/device-platform`, headers);
        } catch (e) {
            return undefined;
        }
        if (!response.ok) {
            return undefined;
        }

        return await response.json();

    }
}
